export default "__VITE_ASSET__181ba3a5__"